$('input[type="tel"]').on('keydown', function(e) {
  if (e.key !== undefined) {
    if(e.key.length == 1 && e.key.match(/[^0-9'".]/)){
      return false;
    }
  }
});